import { NgModule } from '@angular/core';
import { environment } from '@flexyoo/environment';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        authority: environment.eiffageAuthority,
        redirectUrl: environment.eiffageRedirectUrl,
        postLogoutRedirectUri: environment.eiffageRedirectUrl,
        clientId: environment.eiffageClientId,
        scope: 'openid profile email',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        logLevel: LogLevel.Debug,
        triggerAuthorizationResultEvent: true,
        postLoginRoute: '/',
        forbiddenRoute: '/login',
        unauthorizedRoute: '/login',
        historyCleanupOff: true,
      },
    }),
  ],
  exports: [AuthModule],
})
export class OidcAuthConfigModule {}
